


























































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  components: {
    ValidationObserver,
  },
  props: {
    customerId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selectedProduct: null,
      expirationDate: null,
      amountPaid: null,
      isSaving: false,
    };
  },
  computed: {
    ...mapGetters('product', ['teacherProductsExcludeTypePunchCard']),
  },
  methods: {
    async enrollCustomer() {
      try {
        this.isSaving = true;
        const dispatchPromise = await this.$store.dispatch(
          'sale/enrollCustomer',
          {
            customer_id: this.customerId,
            product_id: this.selectedProduct?.id,
            expiration_date: this.expirationDate,
            amount_paid: this.amountPaid,
          }
        );
        await this.$store.dispatch('customer-purchases-table/refresh');
        this.$emit('close');
        this.$emit('onSubmit', dispatchPromise);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('CUSTOMERS.NOTIFICATIONS.CUSTOMER_ENROLL_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('CUSTOMERS.NOTIFICATIONS.CUSTOMER_ENROLL_ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.isSaving = false;
      }
    },
  },
  async mounted() {
    await this.$store.dispatch('product/getTeacherProducts');
  },
});
